<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/inventory/stocktransfer" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("inventory.label.View_MRN") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      v-if="mrn.status !== 'Completed'"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="truncate"
                      @click.stop="editData(id)"
                      size="small"
                      >{{ $t("inventory.label.Edit") }}</vs-button
                    >
                    <vs-button
                      v-if="mrn.status == 'New'"
                      color="warning"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate ml-2"
                      @click.stop="
                        editJobsPopup = true;
                        delId = fee.feeMasterData.id;
                      "
                      size="small"
                      >{{ $t("inventory.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  ></div>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <vx-card title no-shadow card-border>
                <div class="block overflow-x-auto">
                  <table class="table w-full table-bordered table-striped">
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Id") }}</b>
                      </td>
                      <td>{{ mrn.id }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Requested Date") }}</b>
                      </td>
                      <td>{{ mrn.requestedDate | formatedate }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Requested By") }}</b>
                      </td>
                      <td>{{ mrn.fromOffice }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Request From") }}</b>
                      </td>
                      <td>{{ mrn.toOffice }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Item Description") }}</b>
                      </td>
                      <td>{{ mrn.itemDescription }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Ordered Quantity") }}</b>
                      </td>
                      <td>{{ mrn.orderdQuantity }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("stockTransfer.label.Received Quantity") }}</b>
                      </td>
                      <td>{{ mrn.receivedQuantity }}</td>
                    </tr>
                    <tr>
                      <td class="border-none">
                        <b>{{ $t("inventory.label.status") }} </b>
                      </td>
                      <td class="border-none">{{ mrn.status }}</td>
                    </tr>
                  </table>
                </div>
              </vx-card>
              <div class="centerx">
                <vs-popup
                  class="popup-close"
                  :title="$t('inventory.label.DeleteItemModel')"
                  :active.sync="editJobsPopup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">{{$t("inventory.label.Are_you_sure?")}}</div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button type="border" @click="editJobsPopup = false">{{
                        $t("stockTransfer.label.Cancel")
                      }}</vs-button>
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button @click="deleteTeam(delId)" color="warning">{{
                        $t("stockTransfer.label.Ok")
                      }}</vs-button>
                    </span>
                  </div>
                </vs-popup>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
//   viewFeetemplate, deleteTeamTicket,
import {
  deleteItemSale,
  viewGRVStockTransfer,
  getByMrnId,
} from "@/http/inventory";
import moment from "moment";
import vSelect from "vue-select";
export default {
  data() {
    return {
      mrn: "",
      id: "",
      good: {},
      goods: [],
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
      dateFormat: "dd MMMM yyyy",
      requestedDate: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {},
  methods: {
    editData(id) {
      this.$router.push({ name: "Edit MRN", params: { id: id } });
    },
    async getByMrnId() {
      try {
        const response = await getByMrnId(this.id);
        this.mrn = response.data;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving job by id:",
          error
        );
      }
    },
    async deleteTeam(id) {
      try {
        const result = await deleteItemSale(this.id);
        this.editJobsPopup = false;
        this.$router.push(`/inventory`);
        if (result) {
          this.$swal({
            text: `You Deleted the Contract.`,
            duration: 5000,
          }).then(() => {
            this.$router.push(`/fee_master`);
          });
          this.refresh();
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getByMrnId();
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
  watch: {
    editData(newValue) {
      if (newValue) {
        this.viewGRVStockTransfer();
      }
    },
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
